import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import config from './config';

// Import components
import Home from './components/Home';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import Settings from './components/settings/Settings';
import Register from './components/auth/Register';

import UserList from './components/users/UserList';
import UserCreate from './components/users/UserCreate';
import UserEdit from './components/users/UserEdit';

import BackupList from './components/backups/BackupList';
import SourceDatabaseList from './components/source-databases/SourceDatabaseList';
import SourceDatabaseCreate from './components/source-databases/SourceDatabaseCreate';
import SourceDatabaseEdit from './components/source-databases/SourceDatabaseEdit';

import EmailList from './components/emails/EmailList';
import EmailCreate from './components/emails/EmailCreate';
import EmailEdit from './components/emails/EmailEdit';
import SMTPConfigList from './components/smtp/SMTPConfigList';

import TargetConnectionList from './components/targetConnection/TargetConnectionList';



const AppRoutes = ({ isAuthenticated, onLogin, onLogout }) => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/auth/me`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        setUserRole(response.data.role);
      } catch (error) {
        console.error('Error fetching user role:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  const adminRoutes = (
    <>
      {/* Settings */}
      <Route path="/settings" element={<Settings />} />

      {/* User Management */}
      <Route path="/users" element={<UserList />} />
      <Route path="/users/create" element={<UserCreate />} />
      <Route path="/users/edit/:id" element={<UserEdit />} />

      {/* Source Databases */}
      <Route path="/source-databases" element={<SourceDatabaseList />} />
      <Route path="/source-databases/create" element={<SourceDatabaseCreate />} />
      <Route path="/source-databases/edit/:id" element={<SourceDatabaseEdit />} />

      {/* Emails */}
      <Route path="/emails" element={<EmailList />} />
      <Route path="/emails/create" element={<EmailCreate />} />
      <Route path="/emails/edit/:id" element={<EmailEdit />} />
      <Route path="/smtp-config" element={<SMTPConfigList />} />



      {/* Target Connection */}
      <Route path="/target-connection" element={<TargetConnectionList />} />
    </>
  );

  const commonRoutes = (
    <>
      <Route path="/logout" element={<Logout onLogout={onLogout} />} />
      <Route path="/backups" element={<BackupList />} />
    </>
  );

  return (
    <Routes>
      {isAuthenticated ? (
        <>
          {/* Home Route */}
          <Route path="/" element={userRole === 'Admin' ? <Home /> : <Navigate to="/backups" />} />

          {/* Common Routes */}
          {commonRoutes}

          {/* Admin-Specific Routes */}
          {userRole === 'Admin' && adminRoutes}

          {/* Catch-All Redirect for Authenticated Users */}
          <Route path="*" element={<Navigate to="/" />} />
        </>
      ) : (
        <>
          {/* Authentication Routes */}
          <Route path="/login" element={<Login onLogin={onLogin} />} />
          <Route path="/auth/register" element={<Register />} />

          {/* Catch-All Redirect for Unauthenticated Users */}
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
